export const apiCreate = (): string => '/users/roles/create'
export const apiList = (id?: string): string =>
  !id ? '/users/roles/' : `/users/roles/view/${id}`
export const apiUpdate = (id: string): string => `/users/roles/update/${id}`
export const apiDelete = (id: string): string => `/users/roles/delete/${id}`
